/*
 *   Copyright (c) 2021 vlinder Labs Private Limited
 *   All rights reserved.
 *   This software is proprietary of Vlinder Labs Pvt. Ltd and can not be distributed / used for any purpose outside of Vlinder Labs Pvt. Ltd without explicit written consent from the copyright owner.
 */

import {
  IAgentPlugin,
  IPluginMethodMap,
} from '@vlinder-web/plugin-agent-service-react';
// import config from '../../config/checkStatus.config.json';
import axios from 'axios';
import { vappContainer } from '@/application';
import { apiConfig } from '@/config/apiConfig';
import { AppNavigatorService } from '@/AppNavigator';
import { Graphql } from '@common/graphql';
import { GET_STATUS } from '../../api/graphql';
import { StorageModule } from '@vlinder-web/storage-module-react';

export interface ICheckStatusMethods extends IPluginMethodMap {
  checkStatus(args: any): Promise<any>;
}

const loginSrv = () => {
  return vappContainer.get<AppNavigatorService>(
    AppNavigatorService.displayName
  );
};

export class CheckStatusService implements IAgentPlugin {
  readonly methods: ICheckStatusMethods;

  constructor() {
    this.methods = {
      checkStatus: this.checkStatus.bind(this),
    };
  }

  async checkStatus(args: any) {
    console.log(`checkStatus service:`, args);
    let gql = Graphql.withBaseUrl(apiConfig.gql.url);
    const storageService = StorageModule.getInstance();

    // const token = getToken();
    const token = loginSrv()?.getToken();
    if (token) {
      gql = gql.withHeaders({
        authentication: token,
      });
    }
    const client = gql.getClient();
    try {
      if (client) {
        console.log(client);
        const res = await client
          .query(GET_STATUS, {
            ...args,
          })
          .toPromise();
        if (res?.data?.getPaymentDetail) {
          return res?.data?.getPaymentDetail;
          // return  {status: "SUCCESS"}
        }
      }
    } catch (err: any) {
      console.log(`Payment user error`, err?.response?.data);
      throw Error(err?.response?.data?.error?.display_message);
    }
  }
}
